import React from "react";
import Storyblok, { Richtext } from "storyblok-js-client";
import { Icon } from "@tvg/design-system";
import { ModalDetailsList } from "@tvg/sh-lib-beta-program/types/redux";
import Parser from "html-react-parser";
import { QA_LABELS } from "../../utils/constants";
import {
  Article,
  FeatureInfo,
  FeatureInfoRow,
  Text,
  Title
} from "./styled-components";
import { BetaFeatureDetail } from "../BetaFeaturesModal/types";

const storyblokClient = new Storyblok({});
export const buildDescription = (description: Richtext | undefined) =>
  description ? (
    <Article data-qa-label={QA_LABELS.ARTICLE}>
      {Parser(storyblokClient.richTextResolver.render(description))}
    </Article>
  ) : null;

export const buildFeaturesList = (list: ModalDetailsList[] | undefined) =>
  (list || []).map((item, index) => (
    <FeatureInfoRow
      data-qa-label={`${QA_LABELS.FEATURES_LIST}-${index.toString()}`}
      key={`${item.title}-${index.toString()}`}
    >
      <Icon name={item.icon || "error"} size="xl" />
      <FeatureInfo>
        {item.title && <Title>{item.title}</Title>}
        <Text>
          {Parser(
            storyblokClient.richTextResolver.render(
              item.text || { content: [] }
            )
          )}
        </Text>
      </FeatureInfo>
    </FeatureInfoRow>
  ));

export const buildDetails = (details: BetaFeatureDetail | undefined) =>
  details ? (
    <>
      {buildDescription(details.description)}
      {buildFeaturesList(details.list)}
    </>
  ) : null;
